(() => {
  const root = document.querySelector('[data-dbc-configurator]');
  if (!root) return;

  const SLOTS_COUNT = 5;
  const COLOR_TAG_PREFIX = 'Color:';

  const slots = Array.from(root.querySelectorAll('.dbc-slot'));
  const tilesWrap = root.querySelector('[data-dbc-tiles]');
  const filtersWrap = root.querySelector('[data-dbc-filters]');
  const searchEl = root.querySelector('[data-dbc-search]');
  const statusEl = root.querySelector('[data-dbc-status]');
  const priceEl = root.querySelector('[data-dbc-price]');
  const resetBtn = root.querySelector('[data-dbc-reset]');
  const atcBtn = root.querySelector('[data-dbc-atc]');
  const tilesJsonEl = root.querySelector('[data-dbc-tiles-json]');

  const basePriceCents = Number(root.dataset.dbcBasePriceCents || root.dataset.dbcBasePrice || 0);
  const baseVariantId = Number(root.dataset.dbcBaseVariantId || 0);
  const tilesCollectionHandle = root.dataset.dbcTilesCollectionHandle || 'the-tiles';

  const moneyFormat = root.dataset.dbcMoneyFormat || '${{amount}}';

  if (!slots.length || !tilesWrap || !filtersWrap || !tilesJsonEl) {
    console.warn('[dbc] Missing required configurator elements.');
    return;
  }

  /** @type {{handle?:string,title?:string,product_id?:number,variant_id?:number,variant_price?:number,price_cents?:number,variant_price_formatted?:string,preview_image?:string|null,slot_image?:string|null,image?:string|null,tags?:string[]}[]} */
  let ALL_TILES = safeJsonParse(tilesJsonEl.textContent, []);
  if (!Array.isArray(ALL_TILES) || !ALL_TILES.length) {
    console.warn('[dbc] No tiles found in JSON (check your Liquid JSON formatting).');
  }

  let bracelet = Array(SLOTS_COUNT).fill(null);
  let tappedTile = null;
  let activeColor = 'All';
  let query = '';


  const FAV_STORAGE_KEY = 'dbc_favorites_v1';
  /** @type {Set<number>} */
  let favorites = loadFavorites();


  let COLORS = deriveColors(ALL_TILES);


  attachSlotDnD();
  attachSearch();
  attachReset();
  attachAtc();
  renderAll();
  scheduleInitialAllRender();
  loadTilesFromCollectionEndpoint();

  function renderAll() {
    renderColorTabs();
    renderTiles();
    renderSlots();
    updateStatus();
    syncLineItemProperties();
    renderPrice();
  }

  function showTemporaryStatus(message, duration = 2000) {
    if (!statusEl) return;
    statusEl.textContent = message;

    window.clearTimeout(statusEl._dbcTimer);
    statusEl._dbcTimer = window.setTimeout(() => {
      updateStatus();
    }, duration);
  }

  function computeTilesCents() {
    return bracelet.reduce((sum, t) => {
      const c = Number(t?.price_cents ?? t?.variant_price ?? 0);
      return sum + (Number.isFinite(c) ? c : 0);
    }, 0);
  }

  function computeTotalCents() {
    return (Number.isFinite(basePriceCents) ? basePriceCents : 0) + computeTilesCents();
  }

  function formatMoneyFromCents(cents) {
    const value = (Number(cents) || 0) / 100;
    const amount = value.toFixed(2);
    const amountNoDec = String(Math.round(value));

    if (moneyFormat.includes('{{amount_no_decimals}}')) {
      return moneyFormat.replace('{{amount_no_decimals}}', amountNoDec);
    }
    if (moneyFormat.includes('{{amount}}')) {
      return moneyFormat.replace('{{amount}}', amount);
    }
    return `$${amount}`;
  }

  function renderPrice() {
    if (!priceEl) return;
    priceEl.textContent = formatMoneyFromCents(computeTotalCents());
  }


  function renderColorTabs() {
    filtersWrap.innerHTML = '';

    COLORS.forEach((color) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dbc-filter' + (color === activeColor ? ' is-active' : '');
      btn.textContent = `${color} (${countForColor(color)})`;

      btn.addEventListener('click', () => {
        selectFilter(color);
      });

      filtersWrap.appendChild(btn);
    });

    const favBtn = document.createElement('button');
    favBtn.type = 'button';
    favBtn.className =
      'dbc-filter dbc-filter--favorites' + (activeColor === '__FAV__' ? ' is-active' : '');
    favBtn.textContent = `Favorites (${favorites.size})`;
    favBtn.addEventListener('click', () => {
      selectFilter('__FAV__');
    });
    filtersWrap.appendChild(favBtn);
  }

  function selectFilter(color) {
    activeColor = color;
    renderColorTabs();
    renderTiles();
  }

  function scheduleInitialAllRender() {
    const renderAllTilesIfStillDefault = () => {
      if (activeColor !== 'All') return;
      selectFilter('All');
    };

    window.requestAnimationFrame(renderAllTilesIfStillDefault);
    window.setTimeout(renderAllTilesIfStillDefault, 100);
    window.setTimeout(renderAllTilesIfStillDefault, 500);

    if (document.readyState === 'complete') {
      renderAllTilesIfStillDefault();
    } else {
      window.addEventListener('load', renderAllTilesIfStillDefault, { once: true });
    }
  }

  async function loadTilesFromCollectionEndpoint() {
    if (!tilesCollectionHandle) return;

    try {
      const res = await fetch(`/collections/${tilesCollectionHandle}/products.json?limit=250`, {
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) return;

      const data = await res.json();
      const products = Array.isArray(data?.products) ? data.products : [];
      if (!products.length) return;

      const existingVariantIds = new Set(ALL_TILES.map((tile) => Number(tile.variant_id)));
      const additionalTiles = products
        .map(productJsonToTile)
        .filter((tile) => {
          const id = Number(tile?.variant_id);
          if (!Number.isFinite(id) || existingVariantIds.has(id)) return false;
          existingVariantIds.add(id);
          return true;
        });

      if (!additionalTiles.length) return;

      ALL_TILES = ALL_TILES.concat(additionalTiles);
      COLORS = deriveColors(ALL_TILES);

      if (activeColor === 'All') {
        selectFilter('All');
      } else {
        renderColorTabs();
      }
    } catch (err) {
      console.warn('[dbc] Could not load additional collection tiles:', err);
    }
  }

  function productJsonToTile(product) {
    const variant = Array.isArray(product?.variants) ? product.variants[0] : null;
    const image =
      product?.image?.src ||
      (Array.isArray(product?.images) && product.images[0] ? product.images[0].src : null);
    const priceCents = priceToCents(variant?.price);

    return {
      handle: product?.handle || '',
      title: product?.title || '',
      product_id: Number(product?.id) || null,
      variant_id: Number(variant?.id) || null,
      tags: normalizeTags(product?.tags),
      variant_price: priceCents,
      price_cents: priceCents,
      variant_price_formatted: priceCents ? formatMoneyFromCents(priceCents) : '',
      preview_image: image,
      slot_image: image
    };
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);
    }
    return [];
  }

  function priceToCents(price) {
    if (typeof price === 'number') return Math.round(price * 100);
    if (typeof price === 'string') return Math.round((parseFloat(price) || 0) * 100);
    return 0;
  }

  function countForColor(color) {
    if (color === '__FAV__') return favorites.size;
    if (color === 'All') return ALL_TILES.length;
    return ALL_TILES.filter((t) => getTileColor(t) === color).length;
  }

  function getVisibleTiles() {
    let list = ALL_TILES.slice();

    if (activeColor === '__FAV__') {
      list = list.filter((t) => favorites.has(Number(t.variant_id)));
    } else if (activeColor !== 'All') {
      list = list.filter((t) => getTileColor(t) === activeColor);
    }

    if (query) {
      const q = query.toLowerCase();
      list = list.filter((t) => (t.title || '').toLowerCase().includes(q));
    }

    return list;
  }

  function renderTiles() {
    tilesWrap.innerHTML = '';

    const grid = document.createElement('div');
    grid.className = 'dbc-tiles__grid';

    const visible = getVisibleTiles();
    if (!visible.length) {
      const empty = document.createElement('div');
      empty.className = 'dbc-mobilehint';
      empty.textContent =
        activeColor === '__FAV__'
          ? 'No favorites yet. Tap the star on a tile to save it.'
          : 'No tiles match your filters.';
      tilesWrap.appendChild(empty);
      return;
    }

    visible.forEach((tile) => {
      const card = document.createElement('div');
      card.className = 'dbc-tile';
      card.draggable = true;

      card.dataset.variantId = String(tile.variant_id ?? '');

      card.addEventListener('dragstart', (e) => {
        try {
          e.dataTransfer?.setData('application/json', JSON.stringify(tile));
          e.dataTransfer?.setData('text/plain', String(tile.variant_id ?? ''));
        } catch {}
      });

      card.addEventListener('click', () => {
        tappedTile = tile;
        updateStatus(`Tap a slot to place: ${tile.title || ''}`);
        setActiveTile(tile.variant_id);
      });

      const previewSrc = tile.preview_image || tile.image || null;
      if (previewSrc) {
        const imgWrap = document.createElement('div');
        imgWrap.className = 'dbc-tile__image';

        const img = document.createElement('img');
        img.src = previewSrc;
        img.alt = tile.title || '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);

        const fav = document.createElement('button');
        fav.type = 'button';
        fav.className =
          'dbc-tile__fav' + (favorites.has(Number(tile.variant_id)) ? ' is-favorited' : '');
        fav.setAttribute('aria-label', 'Toggle favorite');
        fav.innerHTML = favorites.has(Number(tile.variant_id)) ? '★' : '☆';
        fav.addEventListener('click', (e) => hookupFavClick(e, fav, tile));

        imgWrap.appendChild(fav);
        card.appendChild(imgWrap);
      }

      const name = document.createElement('div');
      name.className = 'dbc-tile__name';
      name.textContent = tile.title || '';
      card.appendChild(name);

      grid.appendChild(card);
    });

    tilesWrap.appendChild(grid);

    if (tappedTile?.variant_id) setActiveTile(tappedTile.variant_id);
  }

  function hookupFavClick(e, favEl, tile) {
    e.preventDefault();
    e.stopPropagation();

    const id = Number(tile.variant_id);
    toggleFavorite(id);
    favorites = loadFavorites();

    favEl.classList.toggle('is-favorited', favorites.has(id));
    favEl.innerHTML = favorites.has(id) ? '★' : '☆';

    renderColorTabs();
    if (activeColor === '__FAV__') renderTiles();
  }

  function setActiveTile(variantId) {
    const idStr = String(variantId ?? '');
    root.querySelectorAll('.dbc-tile').forEach((el) => {
      el.classList.toggle('is-active', el.dataset.variantId === idStr);
    });
  }

  function renderSlots() {
    slots.forEach((slotBtn, idx) => {
      const tile = bracelet[idx];

      slotBtn.innerHTML = '';
      slotBtn.classList.toggle('is-filled', Boolean(tile));

      if (!tile) {
        const plus = document.createElement('span');
        plus.className = 'dbc-slot__plus';
        plus.textContent = '+';
        slotBtn.appendChild(plus);
        slotBtn.draggable = false;
      } else {
        const slotSrc = tile.slot_image || tile.preview_image || tile.image || null;

        if (slotSrc) {
          const img = document.createElement('img');
          img.src = slotSrc;
          img.alt = tile.title || '';
          img.loading = 'lazy';
          slotBtn.appendChild(img);
        } else {
          const txt = document.createElement('span');
          txt.textContent = tile.title || '';
          slotBtn.appendChild(txt);
        }

        const isTouch = window.matchMedia('(hover: none)').matches;
        slotBtn.draggable = !isTouch;

        if (!isTouch) {
          slotBtn.addEventListener(
            'dragstart',
            (e) => e.dataTransfer?.setData('text/plain', `slot:${idx}`),
            { once: true }
          );
        }
      }

      bindSlotTap(slotBtn, idx);
    });
  }

  function bindSlotTap(slotBtn, idx) {
    const clone = slotBtn.cloneNode(true);
    slotBtn.replaceWith(clone);
    slots[idx] = clone;

    const handler = (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (tappedTile) {
        bracelet[idx] = tappedTile;
        tappedTile = null;

        renderTiles();
        renderSlots();
        updateStatus();
        syncLineItemProperties();
        renderPrice();
        return;
      }

      if (bracelet[idx]) {
        bracelet[idx] = null;
        renderSlots();
        updateStatus();
        syncLineItemProperties();
        renderPrice();
      }
    };

    clone.addEventListener('click', handler, { passive: false });
    clone.addEventListener('touchend', handler, { passive: false });
  }

  function attachSearch() {
    if (!searchEl) return;
    searchEl.addEventListener('input', () => {
      query = (searchEl.value || '').trim();
      renderTiles();
    });
  }

  function attachReset() {
    if (!resetBtn) return;
    resetBtn.addEventListener('click', () => {
      bracelet = Array(SLOTS_COUNT).fill(null);
      tappedTile = null;
      renderTiles();
      renderSlots();
      updateStatus('Pick 5 tiles to complete your bracelet.');
      syncLineItemProperties();
      renderPrice();
    });
  }

  function attachSlotDnD() {
    slots.forEach((slotBtn) => {
      if (!slotBtn.dataset.slotIndex) return;

      slotBtn.addEventListener('dragover', (e) => e.preventDefault());

      slotBtn.addEventListener('drop', (e) => {
        e.preventDefault();
        const targetIdx = parseInt(slotBtn.dataset.slotIndex || '0', 10);
        if (!Number.isFinite(targetIdx)) return;

        const plain = e.dataTransfer?.getData('text/plain') || '';

        if (plain.startsWith('slot:')) {
          const fromIdx = parseInt(plain.replace('slot:', ''), 10);
          if (!Number.isFinite(fromIdx) || fromIdx === targetIdx) return;

          const tmp = bracelet[fromIdx];
          bracelet[fromIdx] = bracelet[targetIdx];
          bracelet[targetIdx] = tmp;

          tappedTile = null;
          renderTiles();
          renderSlots();
          updateStatus();
          syncLineItemProperties();
          renderPrice();
          return;
        }

        const json = e.dataTransfer?.getData('application/json');
        if (!json) return;

        const tile = safeJsonParse(json, null);
        if (!tile) return;

        bracelet[targetIdx] = tile;
        tappedTile = null;

        renderTiles();
        renderSlots();
        updateStatus();
        syncLineItemProperties();
        renderPrice();
      });
    });
  }

  function updateStatus(forcedText) {
    if (!statusEl) return;

    if (forcedText) {
      statusEl.textContent = forcedText;
      return;
    }

    const filled = bracelet.filter(Boolean).length;
    statusEl.textContent =
      filled < SLOTS_COUNT
        ? `Pick ${SLOTS_COUNT - filled} more tile(s) to complete your bracelet.`
        : 'Bracelet complete — add to cart.';
  }

  function setConfiguratorAtcReady(isReady) {
    if (!atcBtn) return;

    atcBtn.classList.toggle('is-ready', isReady);
    atcBtn.classList.toggle('is-disabled', !isReady);

    atcBtn.disabled = !isReady; 
    atcBtn.setAttribute('aria-disabled', String(!isReady));
  }

  function makeGroupId() {
    return `dbc_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  }

  function attachAtc() {
    if (!atcBtn) return;

    atcBtn.addEventListener('click', async () => {
      const ready = bracelet.every(Boolean);
      if (!ready) {
        updateStatus('Pick 5 tiles to complete your bracelet before adding to cart.');
        return;
      }

      if (!Number.isFinite(baseVariantId) || baseVariantId <= 0) {
        updateStatus('Base bracelet variant missing. Check base product setting.');
        return;
      }

      const groupId = makeGroupId();

      const braceletProps = buildBraceletProperties(groupId);

      const tileItems = bracelet.map((tile, i) => ({
        id: Number(tile.variant_id),
        quantity: 1,
        properties: {
          _dbc_group: groupId,
          _dbc_role: 'tile',
          _dbc_slot: String(i + 1),
          _dbc_title: tile?.title ? String(tile.title) : ''
        }
      }));

      const items = [
        { id: baseVariantId, quantity: 1, properties: braceletProps },
        ...tileItems
      ];

      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        const data = await res.json().catch(() => null);

        if (!res.ok) {
          const msg = data?.description || data?.message || `Shopify error (${res.status}).`;
          console.warn('[dbc] cart/add.js failed:', res.status, data);
          updateStatus(`Add to cart failed: ${msg}`);
          return;
        }

        showTemporaryStatus('Added to cart ✓');

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      } catch (err) {
        console.warn('[dbc] cart/add.js exception:', err);
        updateStatus('Add to cart failed. Please try again.');
      } finally {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-busy');

        setConfiguratorAtcReady(bracelet.every(Boolean));
      }
    });
  }

  function buildBraceletProperties(groupId) {
    const props = {
      _dbc_group: groupId,
      _dbc_role: 'bracelet'
    };

    return props;
  }

  function getProductForm() {
    const forms = Array.from(document.querySelectorAll('form[action^="/cart/add"]'));
    return forms[0] || null;
  }

  function setAtcDisabled(disabled) {
    const form = getProductForm();
    if (!form) return;

    const btns = Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
    btns.forEach((b) =>
      disabled ? b.setAttribute('disabled', 'disabled') : b.removeAttribute('disabled')
    );
  }

  function syncLineItemProperties() {
    const form = getProductForm();
    if (form) {
      form.querySelectorAll('[data-dbc-prop]').forEach((el) => el.remove());

      bracelet.forEach((tile, i) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[Slot ${i + 1}]`;
        input.value = tile?.title ? String(tile.title) : '';
        input.setAttribute('data-dbc-prop', '1');
        form.appendChild(input);
      });

      setAtcDisabled(!bracelet.every(Boolean));
    }

    setConfiguratorAtcReady(bracelet.every(Boolean));
  }

  function deriveColors(tiles) {
    const set = new Set(['All']);
    tiles.forEach((t) => {
      const c = getTileColor(t);
      if (c) set.add(c);
    });

    const preferred = [
      'Classic Navy',
      'Rail White',
      'National Orange',
      'Devon Blue',
      'Wellington Green',
      'Gold'
    ];
    const arr = Array.from(set);
    const rest = arr.filter((x) => x !== 'All' && !preferred.includes(x)).sort();
    const ordered = preferred.filter((x) => arr.includes(x));
    return ['All', ...ordered, ...rest];
  }

  function getTileColor(tile) {
    const tags = Array.isArray(tile.tags) ? tile.tags : [];
    for (const tag of tags) {
      if (typeof tag === 'string' && tag.startsWith(COLOR_TAG_PREFIX)) {
        const c = tag.replace(COLOR_TAG_PREFIX, '').trim();
        if (c) return c;
      }
    }

    const title = (tile.title || '').trim();
    if (!title) return null;

    const parts = title.split(' - ');
    if (parts.length >= 2) return parts[parts.length - 1].trim() || null;
    return null;
  }

  function loadFavorites() {
    try {
      const raw = localStorage.getItem(FAV_STORAGE_KEY);
      if (!raw) return new Set();
      const arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return new Set();
      return new Set(arr.map((n) => Number(n)).filter((n) => Number.isFinite(n)));
    } catch {
      return new Set();
    }
  }

  function saveFavorites() {
    try {
      localStorage.setItem(FAV_STORAGE_KEY, JSON.stringify(Array.from(favorites)));
    } catch {}
  }

  function toggleFavorite(variantId) {
    if (!Number.isFinite(variantId)) return;
    if (favorites.has(variantId)) favorites.delete(variantId);
    else favorites.add(variantId);
    saveFavorites();
  }

  function safeJsonParse(str, fallback) {
    try {
      return JSON.parse(str);
    } catch {
      return fallback;
    }
  }
})();